import React, { createContext, useContext } from 'react'

import type { Config } from '../../types'

export type ConfigContextValue = {
  config: Config | null
  setConfig: React.Dispatch<React.SetStateAction<Config | null>>
}

const ConfigContext = createContext<ConfigContextValue | undefined>(undefined)

export const ConfigProvider: React.FC<{
  config: Config | null
  setConfig: React.Dispatch<React.SetStateAction<Config | null>>
  children: React.ReactNode
}> = ({ config, setConfig, children }) => {
  const value = React.useMemo(() => ({ config, setConfig }), [config, setConfig])
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
}

export const useConfig = (): ConfigContextValue => {
  const ctx = useContext(ConfigContext)
  if (!ctx) {
    throw new Error('useConfig must be used within a ConfigProvider')
  }
  return ctx
}

export default ConfigContext
